module.exports = __webpack_public_path__ + "static/media/Screenshot_5-thumb.e5aa9ce9.png";